import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Lisa Doe",
        title: "Co-Founder & CEO",
        intro: "Lisa Doe brings her passion for artisanal baking and entrepreneurial spirit to Sweet Delight Bakery. With a deep love for creating memorable desserts, she leads the team in crafting high-quality, handcrafted treats that bring joy to every customer.",
        biography: "With over a decade of experience in the baking industry, Lisa has built Sweet Delight Bakery into a beloved neighborhood destination. Her dedication to sourcing the finest ingredients and perfecting every recipe has earned the bakery numerous accolades. Outside the kitchen, she champions community events and baking workshops to spread her love for sweet creations.",
        contacts: {
            phone: "123-456-7890",
            email: "lisa.doe@sweetdelight.com",
            address: "123 Bakery Lane, Sweetville, CA 12345",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Artisanal Baking", progress: 98 },
            { id: 2, title: "Recipe Development", progress: 95 },
            { id: 3, title: "Customer Experience", progress: 93 },
            { id: 4, title: "Team Leadership", progress: 90 },
            { id: 5, title: "Event Catering", progress: 88 },
            { id: 6, title: "Creative Presentation", progress: 92 },
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Janny Smith",
        title: "Head Baker",
        intro: "Janny Smith is the creative force behind our bakery’s signature treats. Her hands-on approach and love for the art of baking bring fresh, flavorful delights to life every single day.",
        biography: "With years of experience working in renowned bakeries, Janny has perfected the craft of baking artisanal breads, pastries, and cakes. Her commitment to quality and innovation keeps our menu fresh and exciting. Whether experimenting with new recipes or mentoring junior bakers, she pours her heart into every creation.",
        contacts: {
            phone: "321-654-0987",
            email: "janny.smith@sweetdelight.com",
            address: "123 Bakery Lane, Sweetville, CA 12345",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Bread & Pastry Baking", progress: 97 },
            { id: 2, title: "Cake Decorating", progress: 95 },
            { id: 3, title: "Recipe Innovation", progress: 90 },
            { id: 4, title: "Team Mentorship", progress: 88 },
            { id: 5, title: "Kitchen Management", progress: 85 },
            { id: 6, title: "Quality Control", progress: 92 },
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Michael Brown",
        title: "Baker",
        intro: "Michael Brown is a skilled baker known for his attention to detail and dedication to creating perfect pastries and breads every day at Sweet Delight Bakery.",
        biography: "Michael joined Sweet Delight Bakery with a passion for crafting artisanal baked goods. With years of hands-on baking experience, he specializes in breads, croissants, and seasonal desserts. His energy and teamwork keep our kitchen running smoothly and our shelves stocked with fresh delights.",
        contacts: {
            phone: "555-789-1234",
            email: "michael.brown@sweetdelight.com",
            address: "123 Bakery Lane, Sweetville, CA 12345",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Bread Baking", progress: 92 },
            { id: 2, title: "Pastry Preparation", progress: 90 },
            { id: 3, title: "Time Management", progress: 88 },
            { id: 4, title: "Team Collaboration", progress: 85 },
            { id: 5, title: "Ingredient Handling", progress: 87 },
            { id: 6, title: "Cleanliness & Safety", progress: 93 },
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Emily White",
        title: "Cake Decorator",
        intro: "Emily White is a talented cake decorator, turning every dessert into a masterpiece with her creative designs and precise craftsmanship at Sweet Delight Bakery.",
        biography: "Emily brings a unique artistic flair to Sweet Delight Bakery. Specializing in fondant work, buttercream artistry, and themed cake designs, she transforms ordinary cakes into stunning centerpieces. Her creativity and passion shine through in every custom order, making celebrations unforgettable.",
        contacts: {
            phone: "555-321-9876",
            email: "emily.white@sweetdelight.com",
            address: "123 Bakery Lane, Sweetville, CA 12345",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Cake Decorating", progress: 95 },
            { id: 2, title: "Fondant Sculpting", progress: 93 },
            { id: 3, title: "Color Theory", progress: 90 },
            { id: 4, title: "Detail Precision", progress: 92 },
            { id: 5, title: "Theme Design", progress: 88 },
            { id: 6, title: "Client Collaboration", progress: 85 },
        ]
    }

];

export default team;